import { useState } from "react";
import { Lock, Eye, EyeOff } from "lucide-react";

interface PasswordFieldProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
  errors?: string[];
}

export function PasswordField({
  label,
  value,
  onChange,
  placeholder = "••••••••••••",
  disabled = false,
  errors,
}: PasswordFieldProps) {
  const [show, setShow] = useState(false);

  return (
    <div className="space-y-2">
      <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest ml-1">
        {label}
      </label>
      <div className="relative group">
        <Lock
          className="absolute left-5 top-1/2 -translate-y-1/2 text-gray-300 group-focus-within:text-indigo-500 transition-colors"
          size={20}
        />
        <input
          type={show ? "text" : "password"}
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          disabled={disabled}
          className="w-full bg-gray-50 border border-gray-100 rounded-xl pl-14 pr-14 py-4 outline-none focus:ring-4 focus:ring-indigo-50 focus:bg-white transition-all text-gray-900 font-bold disabled:opacity-50"
          required
        />
        <button
          type="button"
          onClick={() => setShow(!show)}
          className="absolute right-5 top-1/2 -translate-y-1/2 text-gray-300 hover:text-gray-600"
        >
          {show ? <EyeOff size={20} /> : <Eye size={20} />}
        </button>
      </div>
      {errors?.map((msg) => (
        <p key={msg} className="text-xs font-bold text-red-500 ml-1">
          {msg}
        </p>
      ))}
    </div>
  );
}
